import graphql__e3466b86c6e609587a8f from "./__generated__/ContributionsDatavizContributionTooltipQuery.graphql.js";
import graphql__7950f6f46ca66d5d6304 from "./__generated__/ContributionsDatavizContributionTooltip_theme.graphql.js";import { graphql, useFragment, useLazyLoadQuery } from "react-relay";
import classNames from "classnames";

import ReactableMeasures from "../ReactableMeasures";
import UserAvatar from "../../../Users/UserAvatar";
import UserAuthorName from "../../../Users/UserAuthorName";
import Icon from "../../../Utils/Icon";

const ContributionsDatavizContributionTooltip = props => {
  const { contributionSlug, onLoaded } = props;
  const { contribution } = useLazyLoadQuery(
    ContributionsDatavizContributionTooltipQuery,
    {
      contributionSlug
    }
  );
  const theme = useFragment(ContributionsDatavizContributionTooltip_theme, props.theme);
  const { primaryColor, primaryContrastColor } = theme;

  const parentTheme = theme.parent;
  const displayedThemeName = parentTheme?.name || theme.name;

  const iconClassNames = theme.iconClass && classNames(["align-middle", theme.iconClass]);

  const { isBookmarked } = contribution;
  const bookmarkIconClassNames = classNames([
    "icon-featured",
    "align-middle",
    "text-shadow-primary",
    "text-primary"
  ]);

  return (
    <div className="idee" ref={onLoaded}>
      <div className="dataviz-box-top-label dataviz-tooltip-theme-label">
        <div
          className="theme"
          style={{
            backgroundColor: primaryColor,
            color: primaryContrastColor
          }}
        >
          <b>{displayedThemeName}</b>
        </div>

        {iconClassNames && (
          <div
            className="icon"
            style={{
              backgroundColor: primaryColor,
              color: primaryContrastColor
            }}
          >
            <Icon className={iconClassNames} />
          </div>
        )}
      </div>
      <div className="author d-flex mb-2">
        <UserAvatar
          user={contribution.author}
          backgroundColor={primaryColor}
          color={primaryContrastColor}
          size={45}
          className="margin-right-xs"
        />

        <UserAuthorName user={contribution.author} withStatusName={true} />
      </div>

      <div className="mb-2 text-default contribution-title">{contribution.title}</div>

      {contribution.themes.map((question, idx) => {
        return (
          <div key={idx} className="question text-secondary">
            {question.name}
          </div>
        );
      })}

      <div className="mt-2">
        <div className="d-flex">
          <ReactableMeasures reactable={contribution} textClassName="text-smaller" />

          {isBookmarked && (
            <div className="bookmark col text-right text-smaller">
              <Icon className={bookmarkIconClassNames} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ContributionsDatavizContributionTooltipQuery = graphql__e3466b86c6e609587a8f;

const ContributionsDatavizContributionTooltip_theme = graphql__7950f6f46ca66d5d6304;

export default ContributionsDatavizContributionTooltip;
